import { render, staticRenderFns } from "./NoticeDialog.vue?vue&type=template&id=107111e6&scoped=true"
import script from "./NoticeDialog.vue?vue&type=script&lang=ts"
export * from "./NoticeDialog.vue?vue&type=script&lang=ts"
import style0 from "./NoticeDialog.vue?vue&type=style&index=0&id=107111e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107111e6",
  null
  
)

export default component.exports